<template>
  <div class="app-container">
    <hear></hear>
    <div class="backoff">
      <div>
        <el-button @click="shuaxin" type="info" icon="el-icon-refresh-right" class="anniu"></el-button>
        <el-button class="anniu" @click="$router.go(-1)">返回</el-button>
      </div>

    </div>
    <!-- <el-dialog title="详情" :visible.sync="open1" fullscreen width="100%" custom-class="infoDetail"> -->
    <el-tabs style="flex:1;" class="tac" tab-position="left">
      <el-tab-pane style="height: 100%;" label="企业基础信息">
        <el-form :model="formLabelAlign" label-width="170px" :disabled="true" class="fromsBox">
          <el-form-item label="公司名称 :">
            <el-input v-model="formLabelAlign.company_name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="法人姓名 :">
            <el-input v-model="formLabelAlign.corporate_information" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="法人联系方式 :">
            <el-input v-model="formLabelAlign.corporate_phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证号 :">
            <el-input v-model="formLabelAlign.corporate_id_number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="法人身份证 :">
            <img width="49%" height="280px" :src="$baseUrl + formLabelAlign.id_card_front" alt />
            <img width="49%" height="280px" :src="$baseUrl + formLabelAlign.id_card_reverse" alt />
          </el-form-item>
          <el-form-item label="统一社会信用代码 :">
            <el-input v-model="formLabelAlign.unify_social_credit_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="企业性质 :">
            <el-input :value="formLabelAlign.enterprise_nature" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="行业代码 :">
            <el-input v-model="formLabelAlign.industry_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="企业邮箱 :">
            <el-input v-model="formLabelAlign.credit_code" autocomplete="off" placeholder="暂无信息"></el-input>
          </el-form-item>
          <el-form-item label="企业地址 :">
            <el-input v-model="formLabelAlign.contact_address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="营业执照 :">
            <img width="100%" height="100%" :src="$baseUrl + formLabelAlign.business_license_pic" alt />
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane style="height: 100%;" label="企业开票信息">
        <el-form :model="formLabelAlign" label-width="170px" :disabled="true" class="fromsBox">
          <el-form-item label="基本户存款账户编号 :">
            <el-input v-model="formLabelAlign.basic_account" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址 :">
            <el-input :value="formLabelAlign.contact_address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开户行 :">
            <el-input v-model="formLabelAlign.account_bank" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户名称 :">
            <el-input v-model="formLabelAlign.account_name" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane style="height: 100%;" label="企业快递地址">
        <div class="left">
          <div class="conter">
   <div style=" padding: 10px; width: 100%;   background: #fff;
    -webkit-box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 16%);
    box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 16%);
    border-radius: 8px 8px 8px 8px;" class="card_content_bottom">

                  <div class="cinoasd">
                    <div class="caakuia">
                      <div>
                        <!-- <span>发件时间：</span>
                        {{ item.createtime | dateFormat }} -->
                      </div>
                      <div></div>
                      <div>
                        <!-- <span>收件时间：</span>
                        暂无 -->
                      </div>
                      <!-- <div class="card_right">
                        <el-button type="primary"  plain>编辑</el-button>
                      </div> -->
                    </div>
                    <div class="kuaidcaa">
                      <div>
                        <img style="width: 124px; height: 124px;"
                          src="https://t12.baidu.com/it/u=3775999286,734565944&fm=58" alt="" srcset="">
                        <!-- <div
                     
                    ></div> -->
                      </div>
               
                      <div class="right_content">
                        <div>
                          <span>收件人：</span>
                          {{ formLabelAlign.company_name }}
                        </div>
                         <div>
                          <span>联系方式：</span>
                          {{ formLabelAlign.corporate_phone }}
                        </div>
                        <div>
                          <span>收货人地址：</span>
                          {{ formLabelAlign.contact_address }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- </el-dialog> -->
    <binad></binad>

    <el-dialog title="修改企业快递地址" :visible.sync="openShow" :close-on-click-modal="false" v-dialogDrag width="50%"
      custom-class="shiming">
      <el-form :model="formAdd" label-width="100px" class="renzhng">
        <el-form-item label="公司名称 :">
          <el-input v-model="formAdd.company_name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式 :">
          <el-input v-model="formAdd.corporate_phone"></el-input>
        </el-form-item>
        <el-form-item label="收货地址 :">
          <el-input v-model="formAdd.contact_address"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="" class="btn" @click="save">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>
  
<script>
// import {
//   listType,
//   getType,
//   delType,
//   addType,
//   updateType
// } from "../../api/system/type";
import { weidaili, daili, company_detail } from "@/api/system/agenciesName.js";
import hear from ".././../components/hear.vue";
import binad from ".././../components/dinad.vue";

export default {
  name: "Type",
  components: {
    hear,
    binad
  },
  data() {
    return {
      activeName: "first",
      cardname:"",
      username:"",
      // 未代理参数
      weidaili_params: {
        offset: 0,
        limit: 10,
        keywords: "",
      },
      weidaili_search: "",
      weidaili_total: null,
      // 代理参数
      daili_params: {
        offset: 0,
        limit: 10,
        keywords: "",
      },
      daili_search: "",
      daili_total: null,
      weidaili_list: [],
      daili_list: [],
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      tableData: [],
      // 字典类型表格数据
      typeList: [
        {
          createBy: "admin",
          createTime: "2022-08-01 12:01:35",
          dictId: 1,
          dictName: "用户性别",
          dictType: "sys_user_sex",
          params: {},
          remark: "用户性别列表",
          searchValue: null,
          status: "0",
          updateBy: null,
          updateTime: null,
        },
      ],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        user_id: 3,
        // pageNum: 1,
        // pageSize: 10,
        // dictName: null,
        // dictType: null,
        // status: null,
        offset: 0,
        limit: 10,
        keywords: "",
      },
      // 表单参数
      form: {},
      formLabelAlign: {

      },
      // 表单校验
      rules: {},
      open1: false,
      openShow: false,
      formAdd: {
        company_name: '',
        corporate_phone: '',
        contact_address: '',
      }
    };
  },
  created() {
    this.get_weidaili();
    this.get_daili();
    this.getDetail(this.$route.params.company_id)
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 新增企业快递地址
    addAdd() {
      console.log(1111);
      this.openShow = true
    },
    // 提交新增企业快递地址
    save() {
      console.log(this.formAdd);
    },




    // 获取详情
    getDetail(id) {
      company_detail(id).then(res => {
        console.log(111111, res.data.data);
        this.formLabelAlign = res.data.data
      })
    },

    // 未代理
    get_weidaili() {
      weidaili(this.weidaili_params).then((res) => {
        if (res.data.code == 1) {
          this.weidaili_list = res.data.data.rows;
          this.weidaili_total = res.data.data.total;
          console.log("未代理列表", this.weidaili_list);
        }
      });
    },
    handleSizeChange(val) {
      this.weidaili_params.limit = val;
      this.get_weidaili();
    },
    handleCurrentChange(val) {
      this.weidaili_params.offset = parseInt(val - 1) * 10;
      this.weidaili_params();
    },
    handleSearch() {
      this.weidaili_params.keywords = this.weidaili_search;
      this.get_weidaili();
    },
    handleSearch1() {
      this.daili_params.keywords = this.daili_search;
      this.get_daili();
    },
    // 已经代理
    get_daili() {
      daili(this.daili_params).then((res) => {
        if (res.data.code == 1) {
          this.daili_list = res.data.data.rows;
          this.daili_total = res.data.data.total;
          console.log("已代理列表", this.daili_list);
        }
      });
    },

    handleSizeChange1(val) {
      this.daili_params.limit = val;
      this.get_daili();
    },
    handleCurrentChange1(val) {
      this.daili_params.offset = parseInt(val - 1) * 10;
      this.get_daili();
    },
    handleClick(row) {
      console.log(row);
    },
    handlesc() {
      console.log("取消代理")
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        dictId: null,
        dictName: null,
        dictType: null,
        status: "0",
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null,
      };
      // this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // this.queryParams.pageNum = 1;
    },
    /** 重置按钮操作 */
    resetQuery() {
      // this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log(selection);
    },
    /** 详情按钮操作 */
    dtails() {
      this.open1 = true;
    },
    /** 修改按钮操作 */
    handleUpdate(row) { },
    /** 提交按钮 */
    submitForm() {
      //   this.$refs["form"].validate(valid => {
      //     if (valid) {
      //       if (this.form.dictId != null) {
      //         updateType(this.form).then(response => {
      //           this.$modal.msgSuccess("修改成功");
      //           this.open = false;
      //           this.getList();
      //         });
      //       } else {
      //         addType(this.form).then(response => {
      //           this.$modal.msgSuccess("新增成功");
      //           this.open = false;
      //           this.getList();
      //         });
      //       }
      //     }
      //   });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // const dictIds = row.dictId || this.ids;
      // this.$modal
      //   .confirm('是否确认删除字典类型编号为"' + dictIds + '"的数据项？')
      //   .then(function() {
      //     return;
      //     delType(dictIds);
      //   })
      //   .then(() => {
      //     this.getList();
      //     this.$modal.msgSuccess("删除成功");
      //   })
      //   .catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      // this.download(
      //   "system/type/export",
      //   {
      //     ...this.queryParams
      //   },
      //   `type_${new Date().getTime()}.xlsx`
      // );
    },
  },
};
</script>
<style scoped lang="scss">
.weidaili_head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search {
  float: right;
  width: 20%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;

  ::v-deep.el-input__inner {
    border: none !important;
  }

  .el-button {
    border: none;
  }
}

::v-deep.el-input__inner {
  border: none !important;
}

.weidaili {
  height: 75vh;
  margin-bottom: 10px;
  overflow: hidden;
}
.card {
    // width: 100%;
    height: 200px;
    background: #fff;
    -webkit-box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 16%);
    box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 16%);
    border-radius: 8px 8px 8px 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    opacity: 1;
    margin: 20px;
    .card_content{
    margin-left: 10px;
    height: 180px;
    opacity: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    .card_content_bottom{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
}
}
.cinoasd{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}
.caakuia{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.kuaidcaa{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-around;
    height: 100%;
    -ms-flex-line-pack: center;
    align-content: center;
}
.right_content {
    margin-left: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: distribute;
    justify-content: space-around;
}
.block {
  width: 95%;
  padding-right: 5%;
  display: flex;
  justify-content: flex-end;
}

.showphoto {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.showphoto1 {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-tabs .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // overflow-y: auto;
}

.app-container {
  height: 100%;
  padding-bottom: 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  // position: relative;
}

// ::v-deep .el-tabs__content {
//   // height: 100% !important;
// }


.fromsBox {
  width: 100%;
      padding: 10px;
     margin: 0px auto;
    margin-top: 60px;
    overflow: auto;

  .el-form-item {
    margin-bottom: 4px;
    margin-left: 20px;
  }

}

.title {
  font-weight: bold;
  margin-bottom: 10px;
}

.left {
  width: 100%;
     display: flex;
    justify-content: center;
  margin-top: 70px;
}

.conter {
  margin-left: 20px;
  // width: 85%;
}

.backoff {
  position: absolute;
  z-index: 999;
  left: 222px;
  top: 83px;
  // margin-left: 180px;
  display: flex;
  justify-content: flex-end;
  padding: 5px 0;
  box-sizing: border-box;

  div {
    width: calc(100vw - 240px);
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }

  .el-button {
    border: 1px solid;
  }
}

.rzBox {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%);

  .el-button {
    width: 150px !important;
  }
}

.renzhng {
  flex: 1;
  overflow-y: auto;
  padding: 0 10%;

  .el-form-item {
    margin-bottom: 4px;
  }
}

.footer {
  display: flex;
  padding-left: 10px;
  box-sizing: border-box;
  height: 45px;
  // justify-content: center;
  align-items: center;
  background-color: #F4F4F5 !important;

  .btn {
    width: 80px;
    height: 35px;
    border: 1px solid #1795ff;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/view/agencies/detail.vue